import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import {
  MemberRole_Employee_getInstance37kv78awnpbvk as MemberRole_Employee_getInstance,
  get_entries3onyqwuzh1iwq as get_entries,
  ProjectState_Terminated_getInstancedn60ew509y4p as ProjectState_Terminated_getInstance,
  ProjectState_Cancelled_getInstanceoirlccakusgk as ProjectState_Cancelled_getInstance,
  ProjectState_Abandoned_getInstance19b47j86nick as ProjectState_Abandoned_getInstance,
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
  ProjectState_Invited_getInstancendchtgzjx7u0 as ProjectState_Invited_getInstance,
  ProjectState_WaitingApproval_getInstance1ditr18fxhnoh as ProjectState_WaitingApproval_getInstance,
  ProjectState_Accepted_getInstance2l1kftynf92aa as ProjectState_Accepted_getInstance,
  ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq as ProjectState_AwaitingFunding_getInstance,
  ProjectState_TransferringFunds_getInstance1fufy8va5bpur as ProjectState_TransferringFunds_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { minus165a8u1e0x1lu as minus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  Projecto73xqbcrzskm as Project,
  ItemChangee3c665suy3yz as ItemChange,
  LineItem2rt64afaiyloc as LineItem,
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_contractor2weo1umt9id6t as get_contractor,
  get_state23zbf4that7g as get_state,
  get_nameo9a32lyl7xbh as get_name,
  get_customer1w9vmrtgthst as get_customer,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../selectedContractor.mjs';
import {
  eq1298m2cje971u as eq,
  xDataClassPathInsideSet1u5agsol0s6ul as xDataClassPathInsideSet,
  inside3oxyfk5qky4sm as inside,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
} from './ProjectView.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { isActive38ua0iq3hv7ll as isActive } from '../../../../../../crowpay-shared/com/crowpay/conditions.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  toggle1hhzkiumllyqn as toggle,
  withWritedlio9p0oewet as withWrite,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_project1h3ocr37wkxs4 as get_project } from '../../../../../../crowpay-shared/com/crowpay/ItemChangeFields.mjs';
import {
  get_project15zbqkhtwq5i6 as get_project_0,
  get_order2yr4ophs8mhb3 as get_order,
} from '../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { AdjustedLineItemjcq04uf63gb9 as AdjustedLineItem } from '../../../utils/AdjustedLineItem.mjs';
import { get_project33kl9j91bsmm2 as get_project_1 } from '../../../../../../crowpay-shared/com/crowpay/PunchListItemFields.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  share11y1uwr9hp0zm as share,
  Action1a4ymn5nx79hk as Action,
} from '../../../utils/utils.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  xlTitle2v7mu4p1j9wv3 as xlTitle,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { subtext2z3zzf0nosi4q as subtext } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme } from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance } from '../../theming/sections.mjs';
import { get_withoutPadding21hnjxk91b1qc as get_withoutPadding } from '../../theming/appTheme.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { expandIcon33yq4ree5qq5m as expandIcon } from '../../components/expansion.mjs';
import {
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  align1ejncrrer3meh as align,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { ProjectStateSemanticzawrm52z9108 as ProjectStateSemantic } from '../../theming/states.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../components/space.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { projectTasks12j3aovmmzdca as projectTasks } from '../../components/project/work/punchList/projectTasks.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  render2ibcvtmr1nr93 as render,
  get_requiredMembershipRole1cjo4vwylx1kv as get_requiredMembershipRole,
  get_finishRegistrationMessage1yrf9ce4f09f0 as get_finishRegistrationMessage,
  get_awaitingApprovalMessage2f85iqlczrbum as get_awaitingApprovalMessage,
  renderFinishRegistrationc1cqjl7so0e8 as renderFinishRegistration,
  renderAwaitingApproval2nft16oqsuwts as renderAwaitingApproval,
  MightBeContractorPage1c5hm6d3mwsqz as MightBeContractorPage,
} from '../contractor/IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ContractorWorkLists$projects$lambda($this$remember) {
  var session = $this$remember.baj(get_session());
  var tmp0_safe_receiver = $this$remember.baj(session.pfw_1).m88_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1;
  var role = tmp1_elvis_lhs == null ? MemberRole_Employee_getInstance() : tmp1_elvis_lhs;
  var activeStatus = minus(toSet(get_entries()), setOf([ProjectState_Terminated_getInstance(), ProjectState_Cancelled_getInstance(), ProjectState_Abandoned_getInstance()]));
  var statuses = !role.equals(MemberRole_Employee_getInstance()) ? activeStatus : minus(activeStatus, setOf([ProjectState_Creating_getInstance(), ProjectState_Invited_getInstance(), ProjectState_WaitingApproval_getInstance(), ProjectState_Accepted_getInstance(), ProjectState_AwaitingFunding_getInstance(), ProjectState_TransferringFunds_getInstance(), ProjectState_Terminated_getInstance(), ProjectState_Cancelled_getInstance(), ProjectState_Abandoned_getInstance()]));
  var tmp2_limit = 2147483647;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp3_condition = and(eq(get_contractor(it), $this$remember.baj(get_notNullContractor())), xDataClassPathInsideSet(get_state(it), statuses));
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$5);
  this_0.o4a(get_state(it_0));
  this_0.m4a(get_name(it_0));
  var tmp4_orderBy = this_0.o1r();
  return $this$remember.baj(session.pfv_1.feo(new (Query())(tmp3_condition, tmp4_orderBy, VOID, tmp2_limit)));
}
var ContractorWorkListsClass;
function ContractorWorkLists() {
  if (ContractorWorkListsClass === VOID) {
    class $ extends WorkListsScreen() {
      constructor() {
        super(ProjectLens_Contractor_getInstance());
        var tmp = this;
        tmp.fjd_1 = remember(VOID, VOID, VOID, ContractorWorkLists$projects$lambda);
      }
      gjd() {
        return this.fjd_1;
      }
    }
    initMetadataForClass($, 'ContractorWorkLists', ContractorWorkLists);
    ContractorWorkListsClass = $;
  }
  return ContractorWorkListsClass;
}
function ClientWorkLists$projects$lambda($this$remember) {
  var session = $this$remember.baj(get_session());
  var tmp0_limit = 2147483647;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp1_condition = and(eq(get_customer(it), session.efv_1), isActive(get_state(it)));
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$5);
  this_0.o4a(get_state(it_0));
  this_0.m4a(get_name(it_0));
  var tmp2_orderBy = this_0.o1r();
  return $this$remember.baj(session.pfv_1.feo(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit)));
}
var ClientWorkListsClass;
function ClientWorkLists() {
  if (ClientWorkListsClass === VOID) {
    class $ extends WorkListsScreen() {
      constructor() {
        super(ProjectLens_Customer_getInstance());
        var tmp = this;
        tmp.tjd_1 = remember(VOID, VOID, VOID, ClientWorkLists$projects$lambda);
      }
      gjd() {
        return this.tjd_1;
      }
    }
    initMetadataForClass($, 'ClientWorkLists', ClientWorkLists);
    ClientWorkListsClass = $;
  }
  return ClientWorkListsClass;
}
function *_generator_invoke__zhh2q8($this, $this$withWrite, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ujd_1.mjd_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.vjd_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp0_safe_receiver = tmp_0.p3(tmp$ret$1.x7a_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp_2 = tmp0_safe_receiver.gah(it, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$Action, $completion) {
  var tmp = toggle($this.wjd_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var WorkListsScreen$renderMainContent$lambda$slambdaClass;
function WorkListsScreen$renderMainContent$lambda$slambda() {
  if (WorkListsScreen$renderMainContent$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $proj) {
        this.ujd_1 = this$0;
        this.vjd_1 = $proj;
      }
      afz($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WorkListsScreen$renderMainContent$lambda$slambdaClass = $;
  }
  return WorkListsScreen$renderMainContent$lambda$slambdaClass;
}
function WorkListsScreen$renderMainContent$lambda$slambda_0(this$0, $proj) {
  var i = new (WorkListsScreen$renderMainContent$lambda$slambda())(this$0, $proj);
  var l = ($this$withWrite, it, $completion) => i.afz($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var WorkListsScreen$renderMainContent$lambda$slambdaClass_0;
function WorkListsScreen$renderMainContent$lambda$slambda_1() {
  if (WorkListsScreen$renderMainContent$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($projExpanded) {
        this.wjd_1 = $projExpanded;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WorkListsScreen$renderMainContent$lambda$slambdaClass_0 = $;
  }
  return WorkListsScreen$renderMainContent$lambda$slambdaClass_0;
}
function WorkListsScreen$renderMainContent$lambda$slambda_2($projExpanded) {
  var i = new (WorkListsScreen$renderMainContent$lambda$slambda_1())($projExpanded);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var WorkListsScreenClass;
function WorkListsScreen() {
  if (WorkListsScreenClass === VOID) {
    class $ {
      constructor(lens) {
        lens = lens === VOID ? ProjectLens_Customer_getInstance() : lens;
        this.hjd_1 = lens;
        var tmp = this;
        tmp.ijd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.baj(this.gjd());
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$0 = item.x7a_1;
            destination.v(tmp$ret$0);
          }
          return destination;
        });
        var tmp_0 = this;
        tmp_0.jjd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).nfv_1;
          // Inline function 'com.lightningkite.lightningdb.Query' call
          var limit = 2147483647;
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ItemChange()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$4);
          var tmp$ret$6 = inside(get_project(it), $this$remember.baj(this.ijd_1));
          var tmp$ret$7 = new (Query())(tmp$ret$6, orderBy, 0, limit);
          return $this$remember.baj(tmp.feo(tmp$ret$7));
        });
        var tmp_1 = this;
        tmp_1.kjd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).mfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$8 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$8);
          var tmp_1 = inside(get_project_0(it), $this$remember.baj(this.ijd_1));
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$13 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$13);
          this_0.m4a(get_order(it_0));
          var tmp$ret$18 = this_0.o1r();
          // Inline function 'kotlin.collections.map' call
          var this_1 = $this$remember.baj(tmp.feo(new (Query())(tmp_1, tmp$ret$18)));
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s = this_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.filter' call
            var tmp0 = $this$remember.baj(this.jjd_1);
            // Inline function 'kotlin.collections.filterTo' call
            var destination_0 = ArrayList().w();
            var _iterator__ex2g4s_0 = tmp0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (element.a6b_1.equals(item.g6k_1)) {
                destination_0.v(element);
              }
            }
            var tmp$ret$22 = AdjustedLineItem().hfy(item, destination_0);
            destination.v(tmp$ret$22);
          }
          return destination;
        });
        var tmp_2 = this;
        tmp_2.ljd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).rfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PunchListItem()), arrayOf([]), false));
          var tmp$ret$25 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$25);
          var tmp$ret$29 = inside(get_project_1(it), $this$remember.baj(this.ijd_1));
          return $this$remember.baj(tmp.feo(new (Query())(tmp$ret$29, VOID, VOID, 2147483647)));
        });
        var tmp_3 = this;
        tmp_3.mjd_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.associateWith' call
          var this_0 = $this$remember.baj(this.ijd_1);
          var result = LinkedHashMap().fc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
          // Inline function 'kotlin.collections.associateWithTo' call
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp$ret$30 = Signal().fak(false);
            result.s3(element, tmp$ret$30);
          }
          return result;
        });
      }
      rgj() {
        return this.hjd_1;
      }
      shf(_this__u8e3s4) {
        var tmp = sizeConstraints(_this__u8e3s4, VOID, get_AppDimensions().eg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        shownDefaultFalse(view, ($this$shownDefaultFalse) => $this$shownDefaultFalse.baj(this.gjd()).i1());
        var tmp_0 = get_centered(view);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'You have no work lists';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.jba(view_0.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_1 = view_0.tb5_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = content;
        }
        tmp_1.fbu(tmp_2);
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        _this__u8e3s4.fbb(p, view);
        _this__u8e3s4.jbb(tmp, view);
        var tmp_3 = _this__u8e3s4.ibb(get_scrolling(_this__u8e3s4), get_unpadded(_this__u8e3s4));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs_1 = _this__u8e3s4.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
        _this__u8e3s4.ebb(p_1, view_1);
        view_1.xbm(true);
        var tmp_4 = KMutableProperty0();
        var tmp_5 = RowOrCol$_get_shown_$ref_m8lfse(view_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('shown', 0, tmp_4, tmp_5, RowOrCol$_set_shown_$ref_7290m6(view_1));
        reactiveScope(view_1, ($this$reactiveScope) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          var tmp$ret$11 = !$this$reactiveScope.baj(this.gjd()).i1();
          this_0.set(tmp$ret$11);
          return Unit_instance;
        });
        xlTitle(view_1, 'Tasks');
        subtext(view_1, 'Manage and add tasks for all projects in one spot.');
        var tmp_6 = sizeConstraints(view_1, VOID, get_AppDimensions().eg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        view_2.zb8(get_px(0));
        var tmp_7 = this.gjd();
        forEachUpdating(view_2, tmp_7, VOID, ($this$forEachUpdating, proj) => {
          var line = share(this.kjd_1, ($this$share, list) => {
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = list.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.jfy().equals($this$share.baj(proj).x7a_1)) {
                destination.v(element);
              }
            }
            return destination;
          });
          var punch = share(this.ljd_1, ($this$share, list) => {
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s = list.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.m7w_1.equals($this$share.baj(proj).x7a_1)) {
                destination.v(element);
              }
            }
            return destination;
          });
          var tmp = remember(VOID, VOID, VOID, ($this$remember) => {
            var tmp0_safe_receiver = $this$remember.baj(this.mjd_1).p3($this$remember.baj(proj).x7a_1);
            return (tmp0_safe_receiver == null ? null : $this$remember.baj(tmp0_safe_receiver)) === true;
          });
          var projExpanded = withWrite(tmp, WorkListsScreen$renderMainContent$lambda$slambda_0(this, proj));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$forEachUpdating.pc());
          var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
          $this$forEachUpdating.ebb(p, view);
          view.xbm(true);
          view.zb8(get_px(0));
          var tmp_0 = get_expandButtonTheme(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Button())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.baj(projExpanded) ? get_withoutPadding(SectionSemantic_getInstance()) : null);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.ebb(p_1, view_1);
          view_1.xbm(false);
          view_1.zb8(get_AppDimensions().mg2_1);
          var tmp_1 = get_centered(view_1);
          view_1.jbb(tmp_1, expandIcon(view_1, ($this$expandIcon) => $this$expandIcon.baj(projExpanded)));
          // Inline function 'com.crowpay.views.theming.subTitle' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (TextView())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.ebb(p_2, view_2);
          view_2.jba(view_2.ob6_1.ybe(SubtitleSemantic_getInstance()));
          var tmp_2 = KMutableProperty0();
          var tmp_3 = TextView$_get_content_$ref_4pzcwl(view_2);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(view_2));
          reactiveScope(view_2, ($this$reactiveScope) => {
            var tmp$ret$19 = $this$reactiveScope.baj(proj).d7b_1;
            this_0.set(tmp$ret$19);
            return Unit_instance;
          });
          view_1.fbb(p_2, view_2);
          var tmp_4 = view_1.ibb(get_expanding(view_1), align(view_1, Align_End_getInstance(), Align_Center_getInstance()));
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (TextView())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.ebb(p_3, view_3);
          view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
          view_3.bbs(Align_End_getInstance());
          var tmp_5 = KMutableProperty0();
          var tmp_6 = TextView$_get_content_$ref_4pzcwl_0(view_3);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_0(view_3));
          reactiveScope(view_3, ($this$reactiveScope) => {
            var tmp$ret$26 = $this$reactiveScope.baj(proj).w7b_1.s9b_1;
            this_1.set(tmp$ret$26);
            return Unit_instance;
          });
          dynamicTheme(view_3, ($this$dynamicTheme) => ProjectStateSemantic().ch1($this$dynamicTheme.baj(proj).w7b_1));
          view_1.fbb(p_3, view_3);
          view_1.jbb(tmp_4, view_3);
          view_0.fbb(p_1, view_1);
          view_0.mbg(Action('Expand Project List', VOID, WorkListsScreen$renderMainContent$lambda$slambda_2(projExpanded)));
          view.fbb(p_0, view_0);
          view.jbb(tmp_0, view_0);
          var tmp_7 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(projExpanded));
          // Inline function 'com.crowpay.views.components.sectionIndentCol' call
          // Inline function 'com.crowpay.views.components.indentedCol' call
          var indent = Indent_Section_getInstance();
          var tmp2 = indent.ygq_1;
          // Inline function 'com.crowpay.views.components.indentedCol' call
          var afterSpace = indent.zgq_1;
          var tmp_8 = get_unpadded(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_4 = view.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
          view.ebb(p_4, view_4);
          var tmp_9;
          var tmp_10 = null;
          if (!((tmp_10 == null ? null : new (Dimension())(tmp_10)) == null)) {
            tmp_9 = sizeConstraints(view_4, VOID, VOID, VOID, VOID, VOID, null);
          } else {
            tmp_9 = Companion_getInstance();
          }
          var tmp_11 = view_4.ibb(tmp_9, indented(view_4, tmp2, afterSpace));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RowOrCol())(view_4.pc());
          var tmp0_elvis_lhs_5 = view_4.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
          view_4.ebb(p_5, view_5);
          view_5.xbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_6 = new (Space())(view_5.pc());
          var tmp0_elvis_lhs_6 = view_5.cbb_1;
          var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
          view_5.ebb(p_6, view_6);
          view_5.fbb(p_6, view_6);
          projectTasks(view_5, proj, line, punch, this.rgj());
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_7 = new (Space())(view_5.pc());
          var tmp0_elvis_lhs_7 = view_5.cbb_1;
          var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
          view_5.ebb(p_7, view_7);
          view_5.fbb(p_7, view_7);
          view_4.fbb(p_5, view_5);
          view_4.jbb(tmp_11, view_5);
          view.fbb(p_4, view_4);
          var tmp$ret$55 = view.jbb(tmp_8, view_4);
          view.jbb(tmp_7, tmp$ret$55);
          greySeparator(view);
          $this$forEachUpdating.fbb(p, view);
          return Unit_instance;
        });
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_6, view_2);
        _this__u8e3s4.fbb(p_1, view_1);
        return _this__u8e3s4.jbb(tmp_3, view_1);
      }
    }
    protoOf($).ucv = get_title;
    protoOf($).ud6 = render;
    protoOf($).bhg = get_requiredMembershipRole;
    protoOf($).chg = get_finishRegistrationMessage;
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    initMetadataForClass($, 'WorkListsScreen', VOID, VOID, [Page(), MightBeContractorPage()]);
    WorkListsScreenClass = $;
  }
  return WorkListsScreenClass;
}
//region block: exports
export {
  ClientWorkLists as ClientWorkListsm2d5ivw4fy3k,
  ContractorWorkLists as ContractorWorkLists2gwrvh4dcfppr,
};
//endregion

//# sourceMappingURL=WorkListsScreen.mjs.map
